import React from 'react';
import { useSpring, animated } from 'react-spring';

const AnimatedText = ({ x, y, ...props }) => {
  const animatedProps = useSpring({
    x,
    y,
  });
  return <animated.text {...props} x={animatedProps.x} y={animatedProps.y} />;
};

export default AnimatedText;
